import React from 'react';
import PropTypes from 'prop-types';
import Assinatura from './Assinatura';

function AssinaturaRodape ({
  localAndData, rg, texto, assinatura, assinatura2
}) {
  return (
    <div style={{fontSize: '18px', padding: '70px 30px 0 40px', minWidth: '800px'}}>
      <p style={{fontSize: '18px', textAlign: 'right'}}>{texto}</p>
       {assinatura && (<div style={{display: 'flex', justifyContent: 'space-between'}}>
        <Assinatura text={assinatura}>
          <div style={{position: 'absolute', top: '-22px', right: '10px', fontWeight: 600}}>
            {rg}
          </div>
        </Assinatura>
        {assinatura2 && <Assinatura text={assinatura2}/>}
      </div>)}
      <div style={{textAlign: 'center', fontSize: '18px', fontWeight: 600, marginBottom: '18px'}}>
        {localAndData}
      </div>
    </div>
  );
}

AssinaturaRodape.propTypes = {
  localAndData: PropTypes.string.isRequired,
  rg: PropTypes.string,
  texto: PropTypes.string,
  assinatura: PropTypes.string,
  assinatura2: PropTypes.string
};

AssinaturaRodape.defaultProps = {
  localAndData: '',
  rg: '',
  texto: '',
  assinatura: 'Assinatura - RG / Identidade',
  assinatura2: ''
};

export default AssinaturaRodape;



// WEBPACK FOOTER //
// ./src/componentes/AssinaturaRodape/index.js